import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HotToastService } from "@ngxpert/hot-toast";
import { AuthService } from "src/services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class SimpleAuthGuard  {

  constructor(private authService: AuthService, private toast: HotToastService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/dashboard']);
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
